import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import { useService } from '~/services/service.base';
import { WrapperService } from '~/services/service.wrapper';
import { ICodeVerification } from '~/views/types';

export const CodeVerification: FC<ICodeVerification> = observer(
    ({ children, onSendVerificationCode, onEnterVerificationCode, showContactInfo }) => {
        const wrapperService = useService(WrapperService);
        const { codeVerificationService } = wrapperService;

        useEffect(() => {
            codeVerificationService.initSendVerificationCode();
        }, []);

        return (
            <React.Fragment>
                <h3 className="verification-code-header">Enter your verification code</h3>
                <p className="verification-code-text">{children}</p>
                <div className="code-input-single-wrap">
                    <input
                        className={
                            'form-control verification-code-single' +
                            (codeVerificationService.isCodeInvalid ? ' error' : '')
                        }
                        autoFocus
                        type="text"
                        autoComplete="one-time-code"
                        inputMode="numeric"
                        maxLength={6}
                        pattern="[0-9]*"
                        value={codeVerificationService.verificationCode}
                        onChange={e =>
                            codeVerificationService.onSingleVerificationCodeChange(
                                e.target.value,
                                onEnterVerificationCode,
                            )
                        }
                        onInput={e =>
                            codeVerificationService.onSingleVerificationCodeChange(
                                (e.target as HTMLInputElement).value,
                                onEnterVerificationCode,
                            )
                        }
                        onPaste={e => {
                            setTimeout(() => {
                                codeVerificationService.onSingleVerificationCodeChange(
                                    (e.target as HTMLInputElement).value,
                                    onEnterVerificationCode,
                                );
                            }, 0);
                        }}
                        onKeyUp={e => codeVerificationService.onSingleVerificationCodeKeyUp(e, onEnterVerificationCode)}
                        placeholder="Enter 6-digit code"
                    />
                </div>
                {codeVerificationService.isCodeInvalid && (
                    <div id="code-invalid" className="code-error-msg">
                        Verification code is wrong
                    </div>
                )}
                {codeVerificationService.isCodeExpired && !codeVerificationService.isCodeInvalid && (
                    <div id="code-expired" className="code-error-msg">
                        Code has expired
                    </div>
                )}
                {codeVerificationService.codeResendForbidden && (
                    <div id="code-resend-delay" className="code-error-msg">
                        An incorrect code has been entered 5 times. Please try again in 10 minutes.
                    </div>
                )}
                <div className="resend-code-wrap">
                    {codeVerificationService.codeLeftSeconds > 0 && (
                        <div id="resend-code-text" className="resend-code-text">
                            Resend Code in &nbsp;
                            <span id="resend-code-time">{codeVerificationService.codeLeftSeconds}</span>&nbsp; Sec
                        </div>
                    )}
                    {codeVerificationService.codeLeftSeconds === 0 && !codeVerificationService.codeResendForbidden && (
                        <div id="resend-code-link-wrap" className="resend-code-link-wrap">
                            <figure>
                                <img src="/assets/img/resend-code-icon.png" alt="" />
                            </figure>
                            <a
                                href="#"
                                id="resend-code-link"
                                className="resend-code-link"
                                onClick={e => codeVerificationService.handleResendClick(e, onSendVerificationCode)}
                            >
                                Resend
                            </a>
                        </div>
                    )}
                    {showContactInfo && codeVerificationService.codeLeftSeconds === 0 && (
                        <div className="resend-code-contact-info">
                            <p>If you did not receive the verification code, please contact customer support.</p>
                            <a href="mailto:customercare@hardrockgames.com">customercare@hardrockgames.com</a>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    },
);
